export const WORKFLOW_PERSIST_KEY = "Reports-workflow";
export const METRICS_TYPE_PERSIST_PROP = "metricsType";

// Event tracking names
export const TRACKING_EVENT_TIME_FRAME =
  "Selected Time Frame (Performance Reports)";
export const TRACKING_EVENT_SORT_BY = "Chart - Sorted DataGrid";
export const TRACKING_EVENT_GROUP_BY = "Chart - Clicked GroupBy";
export const TRACKING_EVENT_ORDER_BY = "Chart - Clicked OrderBy";
export const TRACKING_EVENT_CHART_CLICK = "Chart - Clicked Chart element";
